import { required } from '../../../../utils/validators';

export const constraints = {
  verificationCode: [required()],
};

export interface FormData {
  verificationCode: string;
}
